import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, Banner, Partners, Mission } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Counter />
        <Mission />
        <Testimonials />
        <Team />
        <Banner />
        <Partners />

      </section>

    </>
  );
}

export default AboutUs;